import { render, staticRenderFns } from "./purchaseRetrunRedAccountAction.vue?vue&type=template&id=6a5222da&scoped=true"
import script from "./purchaseRetrunRedAccountAction.vue?vue&type=script&lang=js"
export * from "./purchaseRetrunRedAccountAction.vue?vue&type=script&lang=js"
import style0 from "./purchaseRetrunRedAccountAction.vue?vue&type=style&index=0&id=6a5222da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5222da",
  null
  
)

export default component.exports